import { AsyncPipe, NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, ContentChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TuiLet } from '@taiga-ui/cdk/directives/let';
import { tuiControlValue } from '@taiga-ui/cdk/observables';
import { defer } from 'rxjs';
const _c0 = [[["input"]], "*"];
const _c1 = ["input", "*"];
function TuiInputInline_ng_container_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function TuiInputInline_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 1);
    i0.ɵɵtemplate(2, TuiInputInline_ng_container_0_span_2_Template, 2, 0, "span", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const value_r1 = ctx.tuiLet;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", value_r1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !value_r1);
  }
}
let TuiInputInline = /*#__PURE__*/(() => {
  class TuiInputInline {
    constructor() {
      this.value$ = defer(() => tuiControlValue(this.control));
    }
    static {
      this.ɵfac = function TuiInputInline_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiInputInline)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiInputInline,
        selectors: [["tui-input-inline"]],
        contentQueries: function TuiInputInline_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, NgControl, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.control = _t.first);
          }
        },
        ngContentSelectors: _c1,
        decls: 3,
        vars: 3,
        consts: [[4, "tuiLet"], [1, "t-before", 3, "textContent"], ["automation-id", "tui-input-inline__placeholder", "class", "t-placeholder", 4, "ngIf"], ["automation-id", "tui-input-inline__placeholder", 1, "t-placeholder"]],
        template: function TuiInputInline_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵtemplate(0, TuiInputInline_ng_container_0_Template, 3, 2, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵprojection(2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("tuiLet", i0.ɵɵpipeBind1(1, 1, ctx.value$));
          }
        },
        dependencies: [AsyncPipe, NgIf, TuiLet],
        styles: ["tui-input-inline{position:relative;display:inline-block;white-space:nowrap;box-sizing:border-box}tui-input-inline>.t-before{padding-right:.02em;margin-left:1px;white-space:pre;visibility:hidden}tui-input-inline>.t-placeholder{display:inline-block;min-inline-size:1px;margin-left:-1px}tui-input-inline>input{position:absolute;top:0;left:0;background-color:transparent;padding:inherit;font:inherit;color:inherit;box-sizing:border-box;inline-size:100%;block-size:100%;border-width:0;text-align:inherit;letter-spacing:inherit;text-indent:inherit;text-transform:inherit;outline:none}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiInputInline;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiInputInline };
